import { Center, Loader } from "@mantine/core";

/** A page's loading state: one centered spinner where the page will be. */
export function PageLoader({ label = "Loading" }: { label?: string }) {
  return (
    <Center py="xl">
      <Loader aria-label={label} />
    </Center>
  );
}
